import React, { useMemo } from 'react'
import { Grid, Row, Col } from 'react-bootstrap'

import SimpleTableTable from '../../../../../../../Components/SimpleTableTable'
import { AmbassadorSection } from '../../../../../../../Components/City/Page/Ambassador/AmbassadorSection'
import { SectionTitle } from '../../../../../../../Components/Section/SectionTitle'
import { formatToLocalDate } from '../../../../../../../shared/libraries/utils/date'

const LegalDocumentsSection = ({ signedLegalDocuments, formW9 }) => {
  const data = useMemo(
    () => {
      const formattedSignedDocuments = signedLegalDocuments.map(dto => ({
        'Name': dto.name,
        'URL': dto.url,
        'Signed On': dto.dateTime,
      }))
      if (formW9 && formW9.fileName) {
        const formattedW9Form = {
          'Name': 'W9 Form',
          'URL': formW9.fileName,
          'Signed On': Number(formW9.fileSaveTime),
        }
        return [...formattedSignedDocuments, formattedW9Form]
      }

      return formattedSignedDocuments
    },
    signedLegalDocuments,
    formW9,
  )

  return (
    <AmbassadorSection className="no-padding">
      <Grid fluid>
        <Row className="padding-row">
          <Col xs={12}>
            <SectionTitle>Signed Documents</SectionTitle>
          </Col>
        </Row>
        <Row className="padding-row">
          <Col xs={12}>
            <div className="signed-documents-table">
              <SimpleTableTable
                header={['Name', 'URL', 'Signed On']}
                data={data}
                sortOn={['Name', 'Signed On']}
                postRowRender={m => ({
                  ...m,
                  'URL': (
                    <a href={m['URL']} target="_blank">
                      {m['URL']}
                    </a>
                  ),
                  'Signed On': formatToLocalDate(new Date(m['Signed On'])),
                })}
                showPages={false}
              />
            </div>
          </Col>
        </Row>
      </Grid>
    </AmbassadorSection>
  )
}

export default LegalDocumentsSection



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasador/Components/LegalDocumentsSection/container/LegalDocumentsSection.js